// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ":root {\n    --hue: 220;\n    --sat: 100;\n    --light: 81;\n}\n\n#pivotgrid {\n    margin-top: 20px;\n}\n\n.currency {\n    text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
